import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Definitions",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.definitions.header"
      }
    ]
  },
  noi: {
    label: "NOI",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.noiDefinition",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.noiDefinition"
      }
    ]
  },
  debtService: {
    label: "Debt Service",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.debtServiceDefinition",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.debtServiceDefinition"
      }
    ]
  },
  debtYield: {
    label: "Debt Yield",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.debtYieldDefinition",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.debtYieldDefinition"
      }
    ]
  },
  dscr: {
    label: "DSCR",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.dscrDefinition",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.dscrDefinition"
      }
    ]
  },
  ltv: {
    label: "LTV",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.ltvDefinition",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.ltvDefinition"
      }
    ]
  },
  misc: {
    label: "Misc.",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.definitionsMisc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.definitionsMisc"
      }
    ]
  }
};
